import React, { useRef, useState } from 'react';
import './inputBox.scss';

type InputBoxProps = {
  label?: string;
  value: string;
  onChange?: React.Dispatch<React.SetStateAction<string>>;
  placeHolder?: string;
  editable?: boolean;
  onClick?: () => void;
  maxLength?: number;
  type?: string;
};

type DropDownProps = {
  label?: string;
  options: string[];
  bottomText?: string;
  onSelect?: any;
  value?: string;
  fullWidth?: boolean;
};

type RadioProps<ItemT> = {
  items: ItemT[];
  header: string;
  value: ItemT;
  onChange: (value: string) => void;
};

const InputBox: React.ForwardRefRenderFunction<HTMLInputElement, InputBoxProps> = (
  { label, value, onChange, placeHolder = '', editable = true, maxLength = 20 },
  ref,
) => {
  return (
    <div className={`inputComponent ${label ? '' : 'inputExtender'}  `}>
      <div className="InputLabel"> {label}</div>
      <div className="inputWrapper">
        <input
          ref={ref}
          onChange={(e) => {
            if (onChange) onChange(e.target.value);
          }}
          type="text"
          id="textInput"
          className="textField"
          value={value}
          placeholder={placeHolder}
          disabled={!editable}
          maxLength={maxLength}
        />
      </div>
    </div>
  );
};

const SearchInput = ({
  label,
  value,
  onChange,
  placeHolder = '',
  editable = true,
  onClick,
  maxLength = 20,
}: InputBoxProps) => {
  return (
    <div className="inputComponent">
      <div className="InputLabel"> {label}</div>
      <div className="buttonAndInputContainer">
        <input
          onChange={(e) => {
            if (onChange) onChange(e.target.value);
          }}
          value={value}
          type="input"
          className="searchInputField"
          placeholder={placeHolder}
          disabled={!editable}
          maxLength={maxLength}
        />
        <button className="inputButton" onClick={onClick}>
          주소찾기
        </button>
      </div>
    </div>
  );
};

const DropDown = ({ label, options, bottomText, onSelect, fullWidth = false, value = '' }: DropDownProps) => {
  return (
    <div className="dropDownComponent" style={{ width: fullWidth ? '100%' : '' }}>
      <div className="InputLabel">{label}</div>
      <div className="inputWrapper">
        <select
          className="selectField"
          onChange={(e) => {
            onSelect(e.target.value);
          }}
          value={value}>
          {options.map((option: string) => {
            return (
              <option key={option} value={option}>
                {option}
              </option>
            );
          })}
        </select>
      </div>
      <div className="bottomText">{bottomText}</div>
    </div>
  );
};

const RadioButtons = <ItemT,>({ items, header, value, onChange }: RadioProps<ItemT>) => {
  return (
    <div className="radioHeaderGroup">
      <div className="header">{header}</div>
      {items.map((item: ItemT) => {
        const ITEM = typeof item === 'string' ? item : '';
        return (
          <label key={ITEM} className="radioContainer">
            <div className="itemText">{ITEM}</div>

            <input
              type="radio"
              name={ITEM}
              checked={value === ITEM}
              onChange={(e) => {
                onChange(ITEM);
              }}
            />
            <span className="checkmark"></span>
          </label>
        );
      })}
    </div>
  );
};

export { DropDown, RadioButtons, SearchInput };
export default React.forwardRef(InputBox);
